/**
 * change-schema-visibility-requests.ts
 * Copyright (c) 2016-2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class ChangeDataExportSchemaVisibility extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_CHANGE_DATA_EXPORT_SCHEMA_VISIBILITY;
  public static tag : MessageTag =
    MessageTag.REQ_CHANGE_DATA_EXPORT_SCHEMA_VISIBILITY;

  constructor (public schemaId : number, public isGroupPublic : boolean)
  {
    super();
  }
}

export class ChangeAggregationSchemaVisibility extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_CHANGE_AGGREGATION_SCHEMA_VISIBILITY;
  public static tag : MessageTag =
    MessageTag.REQ_CHANGE_AGGREGATION_SCHEMA_VISIBILITY;

  constructor (public schemaId : number, public isGroupPublic : boolean)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/schemas/change-schema-visibility-requests.ts